export { default } from './CapcaleraGrafic';
